import { chartTableFlatTransformer } from '@/utils/reports/chartTableFlatTransformer';

/**
 * Transforms interview data for feedback and duration charts
 * @param response API response data
 * @param feedbackKeys keys for feedback metrics
 * @returns Object containing data for both charts
 */
export const interviewsVisualsTransformer = ({ response, metadata }) => {
  // Safely extract properties from response
  const { chart = [], headers, lookups, table = [] } = response || {};
  const { dt, g1, g2 } = lookups || {}; // Lookup mappings for data transformation

  const data = g1?.length || g2?.length ? table : chart;
  const headerKey = g1?.length ? 'g1' : 'dt';

  const { tileKey } = metadata || {};

  // Transform raw chart data into a flat structure
  const transformedData = chartTableFlatTransformer({
    headerKey,
    headers,
    data,
    g1,
    g2,
    dt,
  });

  const interviewByFeedback = transformedData?.reduce(
    (acc, curr) => {
      return {
        no: acc?.no + curr?.no,
        yes: acc?.yes + curr?.yes,
        strong_no: acc?.strong_no + curr?.strong_no,
        strong_yes: acc?.strong_yes + curr?.strong_yes,
      };
    },
    { no: 0, yes: 0, strong_no: 0, strong_yes: 0 }
  );

  // Check if all values in interviewByFeedback are zero
  const isAllFeedbackZero = Object.values(interviewByFeedback).every(
    (val) => val === 0
  );

  const interviewByFeedbackData = isAllFeedbackZero
    ? []
    : Object.entries(interviewByFeedback)?.map((feedback) => {
        const [key, value] = feedback;
        return { name: key.split('_').join(' ').toUpperCase(), y: value };
      });

  // Generate interview by duration data
  const interviewByDuration = transformedData?.map((x) => {
    return {
      name: `${x?.header} mins`,
      y: x?.interviews_completed,
      g1: x?.header,
    };
  });

  // Check if all interviewByDuration values are zero
  const isAllDurationZero = interviewByDuration.every((entry) => entry.y === 0);

  const interviewByDurationData = isAllDurationZero ? [] : interviewByDuration;

  // Return based on the tileKey
  if (tileKey === 'interviews_feedback_chart') {
    const categories = interviewByFeedbackData.map((item) => item.name);

    return {
      series: interviewByFeedbackData, // For feedback donut chart
      categories, // For bar/column charts
    };
  }

  if (tileKey === 'interviews_duration_chart') {
    const categories = interviewByDurationData.map((item) => item.name);

    return {
      series: interviewByDurationData, // For duration donut chart
      categories, // For bar/column charts
    };
  }
  return [];
};
